import {
  APIAccountProps,
  APIAssetProps,
  APICodeDeckProps,
  APIDDIProps,
  APIDeviceProps,
  APIEventsProps,
  APINumberPoolProps,
  APIOrganisationChargeProps,
  APIOrganisationMetricsProps,
  APIOrganisationProps,
  APIProductTableProps,
  APIRatingTableProps,
  APIRoleProps,
  APISettingProps,
  APITicketProps,
  APITrunkProps,
  APIUserProps,
  APIVoiceRegionProps,
  APIWebhookProps,
} from "Providers/types";
import React from "react";

const APIAccountContext = React.createContext<APIAccountProps | any>({});

const APITicketContext = React.createContext<APITicketProps | any>({});
const APIOrganisationContext = React.createContext<APIOrganisationProps | any>(
  {}
);
const APIOrganisationChargeContext = React.createContext<
  APIOrganisationChargeProps | any
>({});
const APIOrganisationMetricsContext = React.createContext<
  APIOrganisationMetricsProps | any
>({});

const APIRatingTableContext = React.createContext<APIRatingTableProps | any>(
  {}
);
const APIProductTableContext = React.createContext<APIProductTableProps | any>(
  {}
);
const APICodeDeckContext = React.createContext<APICodeDeckProps | any>({});
const APIAccountDeviceContext = React.createContext<APIDeviceProps | any>({});
const APIAccountDDIContext = React.createContext<APIDDIProps | any>({});
const APIAccountSettingContext = React.createContext<APISettingProps | any>({});
const APIAccountTrunkContext = React.createContext<APITrunkProps | any>({});
const APIAccountAssetContext = React.createContext<APIAssetProps | any>({});
const APIAccountWebhookContext = React.createContext<APIWebhookProps | any>({});
const APIUserContext = React.createContext<APIUserProps | any>({});
const APIRoleContext = React.createContext<APIRoleProps | any>({});
const APIEventsContext = React.createContext<APIEventsProps | any>({});
const APINumberPoolContext = React.createContext<APINumberPoolProps | any>({});

const APIVoiceRegionContext = React.createContext<APIVoiceRegionProps | any>(
  {}
);

export {
  APIAccountAssetContext,
  APIAccountContext,
  APITicketContext,
  APIOrganisationContext,
  APIOrganisationChargeContext,
  APIOrganisationMetricsContext,
  APIRatingTableContext,
  APIProductTableContext,
  APICodeDeckContext,
  APIUserContext,
  APIAccountDeviceContext,
  APIAccountDDIContext,
  APIAccountTrunkContext,
  APIAccountSettingContext,
  APIAccountWebhookContext,
  APIRoleContext,
  APINumberPoolContext,
  APIEventsContext,
  APIVoiceRegionContext,
};
